import Card from "./Card";

function HowToBuy() {
  const cardsData = [
    {
      step: "1",
      title: "Connect Wallet",
      text: "Find the presale widget at the top of this web page and connect your preferred wallet.",
    },
    {
      step: "2",
      title: "Select Network",
      text: "Once connected, you can choose to participate in the $PEPE3D presale on BNB Chain, Ethereum and Polygon are coming soon!",
    },
    {
      step: "3",
      title: "Buy Tokens",
      text: "Enter the amount of BNB or USDT you wish to swap for $PEPE3D and confirm the transaction in your wallet (ETH and MATIC are coming soon).",
    },
    {
      step: "4",
      title: "Claim on Chain",
      text: "Once the presale concludes, you will be able to claim your $PEPE3D tokens using the same wallet and chain you used to buy.",
    },
    {
      step: "5",
      title: "Bridge or Trade",
      text: "$PEPE3D will be tradable on all major chains and DEXs. Simply use the $PEPE3D Bridge to easily switch tokens between chains.",
    },
  ];

  return (
    <div className=" w-full h-full relative z-100 flex justify-center items-center p-2">
      <div className="w-auto sm:w-[70vw] gap-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3">
        <div className="flex justify-center items-center">
           <h1 className=" text-4xl text-slate-100 font-bold uppercase tracking-wider mt-10">
            HOW TO BUY?
          </h1>
        </div>
        {cardsData.map(({ step, title, text }, index) => (
          <Card key={`Card-${index}`} step={step} title={title} text={text} />
        ))}
      </div>
    </div>
  );
}

export default HowToBuy;
